<template>
<div class="mh100vh b_fff">
<div class="vip pt20 pl24 pr24 pb30">
  <div v-if="account.deposit>0" class="tar pb18">
    <router-link :to="{ name: 'rentsrecharge' }" class="fz28 c_333">查看印章</router-link>
  </div>
  <div v-if="type!=2" class="box1 df aic pl24 pt50 pb50 por bdrd8 b_vip c_vip">
    <img v-if="account.photo" :src="account.photo" alt="" class="all88 bdrd50p">
    <img v-else src="./assets/img/p.png" alt="" class="all88 bdrd50p">
    <div class="pl24 por z1">
      <div class="fz28">{{account.nickname}}</div>
      <div v-if="account.huiyuan_expire_at" class="ico df aic">
        <img src="./assets/img/vip_1.png" alt="" class="w28 h25 mr10">
        年费会员有效期至{{account.huiyuan_expire_at_sub}}
      </div>
      <div v-else>您还未开通年费会员</div>
    </div>
    <img src="./assets/img/vip_2.png" alt="" class="w250 h92 poa b0 r20">
    <div v-if="account.deposit>0" @click="showPop" class="w162 lh45 df aic jcc poa r24 t52 bdrd50 b_vip2 fz24 c_vip2">
      <img src="./assets/img/vip_ya.png" alt="" class="w25 h29 mr6">
      <span>押金返还</span>
    </div>
  </div>
  <router-link :to="{ name: 'vipbuy' }" v-if="type!=2" class="mt40 db b_vip c_vip tac bdrd50 lh80 fz28">
    <span v-if="account.huiyuan_expire_at">续费会员</span>
    <span v-else>立即开通</span>
  </router-link>
  <div class="box2 mt20 b_fff">
    <div class="fz32 c_333 pt40 tac">
      <span v-if="account.huiyuan_time>0">正在享受以下服务</span>
      <span v-else>成为年费会员即享特权</span>
    </div>
    <div class="pt6">
      <div v-for="(v,k) in list" class="lnb df pt24 pb24 pl35 pr35 aic c_vip2">
        <img :src="v.ico" alt="" class="all70 bdrd50p">
        <div class="pl16 fz28 fx1">{{v.title}} </div>
        <router-link :to="{ name: 'invite'}" v-if="v.txt" class="c_vip2">{{v.txt}}</router-link>
      </div>
    </div>
  </div>
  <router-link :to="{ name: 'vipbuy' }" v-if="type==2" class="mt24 db b_vip c_vip tac bdrd50 lh80 fz28">
    <span v-if="account.huiyuan_expire_at">续费会员</span>
    <span v-else>立即开通</span>
  </router-link>
</div>
    <yajintips v-if="popShow" @myevent="myevent"></yajintips>

</div>
</template>
<script>
import weui from 'weui.js'
import yajintips from '@/components/yajintips'
export default{
  components:{
    yajintips
  },
  data(){
    return{
      type:this.$route.query.type,
      account:{},
      list:[],
      busy: true,
      load:true,
      page:1,
      list:[
        {ico:require('./assets/img/vip_m9.png'),title:'享受7折洗衣折扣'},
        {ico:require('./assets/img/vip_m4.png'),title:'加入分销享受洗衣提成。',txt:'前往了解>>'},
        {ico:require('./assets/img/vip_m2.png'),title:'VIP专属优惠券'},
        {ico:require('./assets/img/vip_m7.png'),title:'会员积分回馈'},
        
        // {ico:require('./assets/img/vip_m1.png'),title:'享受最高8折洗衣折扣'},
        // {ico:require('./assets/img/vip_m2.png'),title:'VIP客服服务'},
        // {ico:require('./assets/img/vip_m3.png'),title:'洗衣寄存时间延长'},
        // {ico:require('./assets/img/vip_m4.png'),title:'加入分销享受洗衣提成',txt:'前往了解>>'},
        // {ico:require('./assets/img/vip_m5.png'),title:'特殊衣物保障服务'},
        // {ico:require('./assets/img/vip_m6.png'),title:'洗衣门店专属贴心提醒'},
        // {ico:require('./assets/img/vip_m7.png'),title:'会员积分回馈'},
        // {ico:require('./assets/img/vip_m8.png'),title:'不定时开办会员活动'}
      ],
      popShow:false
    }
  },
  mounted() {
    this.getAccount();
  },
  methods:{
    showPop(){
        this.popShow = true;
    },
    myevent(e){
      if(e.refresh){
          this.getAccount();
      }
      if(e.close){
        this.popShow = false;
      }
    },
    getAccount(){
      let vm = this;
      vm.ajax("account", "get", '', e => {
        vm.account = e.data;
        // // //test
             //     //   vm.account.honor = 3;
            // vm.account.huiyuan_expire_at = ''//未开通会员
            // vm.account.huiyuan_expire_at = '2021-12-06 22:22:22'//会员中
            // vm.account.huiyuan_expire_at = '2020-12-06 22:22:22'//会员过期
             // //test
        vm.account.huiyuan_expire_at_sub = vm.account.huiyuan_expire_at.substr(0,10);
        if(vm.account.deposit>0) vm.popShow = true;
        if(vm.account.huiyuan_expire_at){
            let huiyuan_time = new Date(vm.account.huiyuan_expire_at.replace(/-/g,'/')).getTime() - new Date().getTime();
            vm.account.huiyuan_time = huiyuan_time;//>0标示有会员
        }
      })
    },
    getAccountMoneyLog(flag){
      let vm = this;
      vm.ajax("account/money/log", "get", 'page='+vm.page, e => {
        vm.load = false;
        if(e.data.list){
          if(flag){
            vm.list =  vm.list.concat(e.data.list)
            if(e.data.count == vm.page){
                vm.busy = true;
            }else{
                vm.busy = false;
            }
          }else{
            vm.list =  e.data.list;
            if(vm.list.length < e.data.limit){
              vm.busy = true;
            }else{
              vm.busy = false;
            }
          }
        }else{
          vm.busy = true;
        }
      })
    },
    loadMore() {
      let vm = this;
      vm.busy = true;
      vm.load = true;
      setTimeout(() => {
          vm.page++;
          vm.getAccountMoneyLog(true);
      }, 1000);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/vip.vue